import { render, staticRenderFns } from "./PostsDataWrapper.vue?vue&type=template&id=c6fea8c4&scoped=true&"
import script from "./PostsDataWrapper.vue?vue&type=script&lang=js&"
export * from "./PostsDataWrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PostsDataWrapper.vue?vue&type=style&index=0&id=c6fea8c4&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c6fea8c4",
  "03231b1b"
  
)

export default component.exports